//
//
//
//
//
//
//
//
//
//

import { staticHost } from "@/common/js/config";
export default {
  props: {
    imgUrl: {
      default: ""
    },
    name: {
      default: ""
    },
    price: {
      default: 0
    },
    showJB: {
      default: false
    },
    id: {
      default:0
    }
  },
  data() {
    return {
      staticHost
    };
  },
  methods:{
    goDetail(){
      this.$emit('goDetail', this.courseId)
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Lession.vue